<template>
  <section id="choose-price"
           class="uk-margin-large-top uk-margin-medium-bottom uk-padding-large uk-padding-remove-horizontal"
           v-if="price.list"
  >
    <div class="uk-container uk-container-large">
      <div class="uk-align-center uk-width-1-1 uk-width-2-3@m">
        <h2 class="uk-h2">1. Preiskategorie w&auml;hlen</h2>
        <div class="uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m uk-child-width-1-5@l" data-uk-grid>
          <div v-for="p in sortedPrices" v-bind:key="p.id">
            <button class="uk-button uk-button-default uk-text-large"
                    v-bind:class="isSelected(p.id)"
                    v-on:click="setPrice(p.id, p.title, p.amount)"
                    v-on:mouseover="showId = p.id"
                    v-on:mouseout="showId = 0"
            >{{p.amount + ' €'}}
            </button>
          </div>
        </div>
        <div class="description uk-margin-medium-top">
          <transition-group v-on:enter="enter"
                            v-on:leave="leave"
                            v-on:before-leave="beforeLeave"
          >
            <template v-for="p in sortedPrices">
              <div v-bind:class="p.id === showId ? 'active' : ''"
                   v-bind:key="p.id" v-html="p.body_text"
                   v-if="p.id === showId"
              ></div>
            </template>
          </transition-group>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {mapGetters} from 'vuex'
import {PRICE_QUERY} from '../../constants/graphql'
import _ from 'lodash'
import {Power2, TweenMax} from 'gsap'
import EventBus from '../../event-bus'

export default {
  name: 'choose-price',
  data () {
    return {
      price: {},
      showId: 0
    }
  },
  apollo: {
    price: {
      query: PRICE_QUERY
    }
  },
  computed: {
    sortedPrices () {
      return _.sortBy(this.price.list, ['amount'])
    },
    ...mapGetters(['chosenPrice'])
  },
  methods: {
    setPrice (id, title, amount) {
      EventBus.$emit('HIDE_PIPES', 'Hide Pipes')
      this.$store.dispatch('setPrice', {id: id, title: title, amount: amount})
    },
    isSelected (id) {
      return this.chosenPrice.id === id ? 'selected' : 'disabled'
    },
    enter: function (el, done) {
      TweenMax.to(document.querySelector('#choose-price .description'),
        0.3, { height: '17vh', ease: Power2.easeInOut })
      TweenMax.to(el, 0.75, { y: '3em', autoAlpha: 1, ease: Power2.easeInOut })
      done()
    },
    leave: function (el, done) {
      TweenMax.to(document.querySelector('#choose-price .description'),
        0.3, { height: 0, ease: Power2.easeInOut })
      done()
    },
    beforeLeave: function (el) {

    }
  }
}
</script>
<style lang="scss">
  @import "~uikit/src/scss/variables-theme";
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  #choose-price {
    .uk-button-default {
      width: 100%;
      white-space: nowrap;
      @media (min-width: $breakpoint-medium) {
        padding: 3px 30px;
      }
      @media (min-width: $breakpoint-large) {
        padding: 3px 33px;
      }
      @media (min-width: $breakpoint-xlarge) {
        padding: 3px 50px;
      }
    }
    background: transparentize($color-light-blue, 0.8);
    .description {
      p {
        @include fontSize(21px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorPage/ChoosePrice.vue